export interface Oefening {
    Id: string
    Status: number
    Naam: string
    Omschrijving: string
    Herhalingen: number
    Tijdsduur: number
    Afstand: number
    Calorien: number
    Video: {
        Naam: string
        Url: string
    }
    isExpanded: boolean
}

export enum WorkoutStatus {
    Gestart,
    Afgerond,
}

export interface WorkoutCMSData {
    Categorie: {
        Naam: string
        Alias: string
        Id: string
    }
    Id: string
    ProfielWorkout: number
    Status: number
    Naam: string
    Niveau: {
        Id: string
        Naam: string
        Url: string
    }
    Omschrijving: string
    Videos: {
        Naam: string
        Url: string
    }[]
    WorkoutPdfLink: {
        Name: string
        Target: string
        Url: string
    }
    Materiaal: {
        Naam: string
        Icon: string
    }[]
    Folder: {
        Id: string
        Naam: string
    }
    Training: {
        Id: string
        Naam: string
        ImageUrl: string
        Url: string
    }
    Onderdelen: {
        Id: string
        Naam: string
        Omschrijving: string
        Oefeningen: Oefening[]
    }[]
}

export interface TrainingCMSData {
    Categorie: {
        Naam: string
        Alias: string
        Id: string
    }
    Folder: {
        Id: string
        Naam: string
    }
    ImageUrl: string
    Naam: string
    Niveau: {
        Id: string
        Naam: string
        Url: string
    }
    Niveaus: {
        Id: string
        Naam: string
        Url: string
        IsAfgerond: boolean
    }[]
    Stats: {
        Afstand: number
        AfstandAfgerond: number
        Calorieen: number
        CalorieenAfgerond: number
        Tijdsduur: number
        TijdsduurAfgerond: number
        Trainingen: number
        TrainingenAfgerond: number
        Categorie: string
        Link: string
        Niveau: string
        Training: string
    }
    Workouts: {
        Id: string
        Naam: string
        Url: string
        Materiaal: {
            Naam: string
            Icon: string
        }[]
        WorkoutOnderdelen: {
            Naam: string
            Omschrijving: string
        }[]
        CurrentProfielWorkout: number
        CurrentProfielWorkoutStatus: WorkoutStatus
        Onderdelen: number
        OnderdelenAfgerond: number
        Afstand: number
        AfstandAfgerond: number
        Calorieen: number
        CalorieenAfgerond: number
        Tijdsduur: number
        TijdsduurAfgerond: number
    }[]
}


export type ObjectValues<T> = T[keyof T]
export const CMS_DATA_ID = {
    ACTIVITEITEN_SEARCH: "ActiviteitenSearch",
    ACTIVITEITEN_SEARCH_HEADER: "ActivitySearchHeader",
    ACTIVITEITEN_MAP: "ActivityMap",
    ACTIVITEITEN_WIDGET: "SportmatchActiviteitWidget",
    SEARCH: "Search",
} as const

export type CmsDataId = ObjectValues<typeof CMS_DATA_ID>

class CmsDataProvider {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private data: Record<string, any>;
    constructor() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.data = (window as any).__CMS_DATA || {};
    }

    get<T>(id: string): T {
        const data = this.data[id];
        if (!data) {
            throw new TypeError(`no data available for id: '${id}'`);
        }
        return data;
    }
}

export default new CmsDataProvider();
